import { memo, useMemo } from 'react';
import { Platform } from 'react-native';
import { Text } from '@bonanza-social/moonlight';
import { Trans } from '@bonanza-social/i18n';
import { StatusBoxesHeaderProps } from './types';

function StatusBoxesHeader({
  statusName,
  pendingRewardsCount,
}: StatusBoxesHeaderProps) {
  const statusColorProps = useMemo(
    () =>
      Platform.select({
        ios: { gradient: `darkSurfaceStatus${statusName}` },
        web: { gradient: `darkSurfaceStatus${statusName}` },
        android: { color: `darkSurfaceSolidStatus${statusName}` },
      }),
    [statusName],
  );
  const transComponents = useMemo(
    () => ({
      status: <Text nested variant="body-s-semi" {...statusColorProps} />,
    }),
    [statusColorProps],
  );

  const variant = useMemo(
    () => (pendingRewardsCount === 1 ? 'single' : 'multiple'),
    [pendingRewardsCount],
  );

  if (!pendingRewardsCount || !statusName) {
    return null;
  }

  return (
    <Text variant="body-s" color="darkSurfacePrimary" textAlign="center">
      <Trans
        ns="status"
        components={transComponents}
        i18nKey={`status_boxes_message_${variant}`}
        values={{
          status: statusName,
          numberOfBoxes: pendingRewardsCount,
        }}
      />
    </Text>
  );
}

export default memo(StatusBoxesHeader);
